/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IntakesAndOutputsListAliases {
  DATE_PICKER_FINAL_DATE_INTAKES_OUTPUTS = 'date-picker-final-date-intakes-outputs',
  DATE_PICKER_INITIAL_DATE_INTAKES_OUTPUTS = 'date-picker-initial-date-intakes-outputs',
  FETCH_INTAKES_OUTPUTS = 'fetch-intakes-outputs',
  FILTER_FIELD_DATE_END_INTAKES_OUTPUTS = 'filter-field-date-end-intakes-outputs',
  FILTER_FIELD_DATE_START_INTAKES_OUTPUTS = 'filter-field-date-start-intakes-outputs',
  FILTER_INTAKES_OUTPUTS = 'filter-intakes-outputs',
  FILTERED_LIST_INTAKES_OUTPUTS = 'filtered-list-intakes-outputs',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INTAKES_AND_OUTPUTS_PANEL = 'intakes-and-outputs-panel',
  INTAKES_CONTEXT = 'intakes-context',
  INTAKES_OPTION = 'intakes-option',
  INTAKES_OUTPUTS_DECK = 'intakes-outputs-deck',
  INTAKES_OUTPUTS_OUTPUTS_CARD = 'intakes-outputs-outputs-card',
  LAYOUT_INTAKES_OUTPUTS_TAB = 'layout-intakes-outputs-tab',
  LEGENDS_INTAKES_OUTPUTS = 'legends-intakes-outputs',
  MAIN_CONTEXT_MENU = 'main-context-menu',
  OUTPUTS_OPTION = 'outputs-option',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
}
export { IntakesAndOutputsListAliases };
